/* eslint-disable */
export default {
  ru: {
    toggle: {
      hidden: 'Открыть сравнительную<br> таблицу тарифов',
      visible: 'Скрыть сравнительную<br> таблицу тарифов',
    },
    tabs: {
      full: 'Все возможности',
      differences: 'Только отличия',
    },
    year: 'год',
    tariffs: {
      title: 'Тариф',
      professional: 'Профессиональный',
      professionalShort: 'Про',
      maximum: 'Максимальный',
      maximumShort: 'Макс',
      enterprise: 'Премьер',
    },
    price: {
      title: 'Стоимость рабочего места рекрутера',
      caption: 'в&nbsp;год за&nbsp;рабочее<br> место рекрутера',
      enterprise:
        "<button class='premier-request-button' data-modal='#demoRequestModal'>Заявка в отдел<br> продаж</button>",
      enterpriseShort:
        "<button class='premier-request-button' data-modal='#demoRequestModal'>Заявка в&nbsp;продажи</button>",
      enterpriseSticky:
        "<span class='text'>Премьер</span><br><button class='premier-request-button' data-modal='#demoRequestModal'>Заявка в отдел продаж</button>",
    },
    recruiters: {
      title: 'Лимит на&nbsp;приобретение рабочих мест рекрутеров',
      professional: 'До&nbsp;15 рабочих мест',
      maximum: 'До&nbsp;15 рабочих мест',
      enterprise: 'Без ограничений',
    },
    ai: {
      title: 'Искусственный интеллект Хантфлоу&nbsp;AI',
      professional: 'Без ограничений',
      maximum: 'Без ограничений',
      enterprise: 'Без ограничений',
    },
    options: {
      unlimited: 'Без ограничений',
      unlimitedRecruiters: 'Любое число рекрутеров',
    },
    hint: 'Подсказка',
    additionalPay: 'Платная функциональность',
  },
  en: {
    title: 'Compare the plans',
    toggle: {
      hidden: 'Open comparative<br> table of&nbsp;plans',
      visible: 'Hide comparative<br> table of&nbsp;plans',
    },
    tabs: {
      full: 'All&nbsp;options',
      differences: 'Only the differences',
    },
    year: 'year',
    tariffs: {
      title: 'Plan',
      professional: 'Professional',
      professionalShort: 'Pro',
      maximum: 'Maximum',
      maximumShort: 'Max',
      enterprise: 'Premier',
    },
    price: {
      title: 'Cost',
      caption: 'Per recruiter/year',
      enterprise: "<button class='premier-request-button' data-modal='#demoRequestModal'>Contact<br> sales</button>",
      enterpriseShort: "<button class='premier-request-button' data-modal='#demoRequestModal'>Contact sales</button>",
      enterpriseSticky:
        "<span class='text'>Premier</span><br><button class='premier-request-button' data-modal='#demoRequestModal'>Contact sales</button>",
    },
    recruiters: {
      title: 'Limit of&nbsp;workplaces for recruiters',
      professional: 'Up&nbsp;to&nbsp;15 workplaces',
      maximum: 'Up&nbsp;to&nbsp;15 workplaces',
      enterprise: 'Unlimited',
    },
    ai: {
      title: 'Artificial Intelligence Huntflow&nbsp;AI',
      professional: 'Unlimited',
      maximum: 'Unlimited',
      enterprise: 'Unlimited',
    },
    options: {
      unlimited: 'Unlimited',
    },
    hint: 'Hint',
    additionalPay: 'Paid feature',
  },
};
